import React, { Component } from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import './FullWindowWrapper.css';
import { IconLoader } from 'common/IconLoader';

class FullWindowWrapper extends Component {
  state = {
    isOpen: true
  };

  componentDidMount() {}

  render() {
    return (
      <div>
        <div>
          <div className="fullWindowContainer">
            <div className="fullWindowHeader">
              {/* <div className="iframeNewTabButton" onClick={() => {this.props.isOpen(false); window.open(this.props.link, "_blank")}}>
                  <SvgAF img={IconLoader.icon_open_new/>} hover={IconLoader.icon_open_new_hover/>} />
                </div> */}
              <div
                className="fullWindowCloseButton"
                onClick={() => {
                  this.props.sendClose();
                }}
              >
                <SvgAF img={IconLoader.icon_close_mid} hover={IconLoader.icon_close_mid_hover} />
              </div>
            </div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default FullWindowWrapper;
